<template>
  <v-card outlined class="pa-4">
    <v-row>
      <v-col cols="12" sm="6">
        <v-menu
          ref="endDateMenu"
          v-model="endDateMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="formattedEndDate"
              label="Ngày kết thúc"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
              :rules="[(v) => !!v || 'Ngày kết thúc là bắt buộc']"
              required
            ></v-text-field>
          </template>
          <v-date-picker v-model="localEndDate" no-title scrollable @input="updateDateTime">
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="endDateMenu = false">Hủy</v-btn>
            <v-btn text color="primary" @click="$refs.endDateMenu.save(localEndDate)">OK</v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" sm="6">
        <v-menu
          ref="endTimeMenu"
          v-model="endTimeMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="formattedEndTime"
              label="Giờ kết thúc"
              prepend-icon="mdi-clock-outline"
              readonly
              v-bind="attrs"
              v-on="on"
              :rules="[(v) => !!v || 'Giờ kết thúc là bắt buộc']"
              required
            ></v-text-field>
          </template>
          <v-time-picker v-model="localEndTime" format="24hr" @input="updateDateTime">
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="endTimeMenu = false">Hủy</v-btn>
            <v-btn text color="primary" @click="$refs.endTimeMenu.save(localEndTime)">OK</v-btn>
          </v-time-picker>
        </v-menu>
      </v-col>
    </v-row>
    <v-card-text class="pt-0">
      <v-alert v-if="formattedEndDateTime" type="info" dense text class="mt-2">
        Thời gian kết thúc: {{ formattedEndDateTime }}
      </v-alert>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    endDateTime: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      localEndDate: null,
      localEndTime: null,
      localEndDateTime: null,
      endDateMenu: false,
      endTimeMenu: false,
    }
  },
  computed: {
    formattedEndDate() {
      return this.localEndDate ? moment(this.localEndDate).format('DD-MM-YYYY') : ''
    },
    formattedEndTime() {
      return this.localEndTime || ''
    },
    formattedEndDateTime() {
      if (this.localEndDateTime) {
        return moment(this.localEndDateTime).format('DD-MM-YYYY HH:mm')
      }
      return null
    },
  },
  methods: {
    updateDateTime() {
      if (this.localEndDate && this.localEndTime) {
        this.localEndDateTime = moment(`${this.localEndDate} ${this.localEndTime}`, 'YYYY-MM-DD HH:mm').toISOString()
        this.$emit('update:end-date-time', this.localEndDateTime)
      }
    },
  },
  watch: {
    endDateTime: {
      handler(val) {
        if (val) {
          const dateTime = moment(val)
          if (dateTime.isValid()) {
            this.localEndDate = dateTime.format('YYYY-MM-DD')
            this.localEndTime = dateTime.format('HH:mm')
            this.localEndDateTime = val
          } else {
            console.error('Invalid endDateTime prop:', val)
            this.localEndDate = null
            this.localEndTime = null
            this.localEndDateTime = null
          }
        } else {
          this.localEndDate = null
          this.localEndTime = null
          this.localEndDateTime = null
        }
      },
      immediate: true,
    },
  },
}
</script>
